import { AppSidebar } from "@/components/AppSidebar";
import { SidebarInset } from "@repo/ui/components/Sidebar";
import { SidebarProvider } from "@repo/ui/providers/SidebarProvider";
import { Outlet } from "react-router";

export const Layout = () => {
  return (
    <SidebarProvider defaultOpen={false}>
      <AppSidebar />
      <SidebarInset>
        <Outlet />
      </SidebarInset>
    </SidebarProvider>
  );
};
